import React from 'react'

import { Hospital } from 'domain/entities/hospital-model'
import { AddDoctor } from 'domain/usecases/doctor/add-doctor'
import AddDoctorForm from 'presentation/hospital/components/Forms/AddDoctor'

import ContainerNew from 'presentation/hospital/components/ContainerNew'

type AddDoctorLayoutProps = {
  addDoctor?: AddDoctor
  hospitals?: Hospital[]
}

export default function AddDoctorLayout({
  addDoctor,
  hospitals
}: AddDoctorLayoutProps) {
  return (
    <ContainerNew>
      <AddDoctorForm hospitals={hospitals} addDoctor={addDoctor} />
    </ContainerNew>
  )
}
